import { Form, Tooltip } from 'antd';
import { Rule } from 'antd/es/form';
import React from 'react';

interface IProps {
  name: string;
  fieldLabel?: string;
  boldLabel?: boolean;
  tooltip?: string | undefined;
  children: React.ReactElement;
  defaultValue?: string | boolean;
  customValidator?: (e, value) => void;
  customRules?: Rule[];
  required?: boolean;
  className?: string;
  hasFeedback?: boolean;
  errorName?: string;
}

export const CardFormField: React.FC<IProps> = ({
  name,
  fieldLabel,
  boldLabel,
  tooltip,
  children,
  defaultValue,
  customValidator,
  customRules = [],
  required = true,
  className = '',
  hasFeedback = false,
  errorName,
}) => {
  const messageLabel = fieldLabel
    ? fieldLabel.includes('*') || fieldLabel.endsWith(':')
      ? fieldLabel.slice(0, -1)
      : fieldLabel
    : undefined;

  return (
    <Form.Item
      key={name}
      label={
        fieldLabel ? (
          <div
          // style={{ display: 'flex', alignItems: 'center', paddingTop: '2pt' }}
          >
            {boldLabel ? <strong>{fieldLabel}</strong> : fieldLabel}
            {tooltip && tooltip.length > 0 && (
              <Tooltip title={tooltip}>
                <div className="field-label-tooltip">?</div>
              </Tooltip>
            )}
          </div>
        ) : undefined
      }
      name={name}
      validateFirst={true}
      initialValue={defaultValue}
      getValueFromEvent={customValidator}
      rules={[
        {
          required: required,
          message: `Please input ${
            errorName
              ? errorName
              : messageLabel
              ? messageLabel
              : 'required field'
          }`,
        },
        ...customRules,
      ]}
      validateTrigger="onChange"
      // className={className}
      hasFeedback={hasFeedback}
    >
      {children}
    </Form.Item>
  );
};
